import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/templates/code.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Image`}</h1>
    <p>{`Image is a wrapper for the native image tag with support for events and fallback images.`}</p>
    <p>{`Always provide alt text for your users, unless the image is purely decorative, in which case the alt text should be an empty string ("") to hide it from screen readers.`}</p>
    <pre><code parentName="pre" {...{}}>{`<Image
  source="https://images.unsplash.com/photo-1449023859676-22e61b0c0695?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1789&q=80"
  alt="Starling"
/>
`}</code></pre>
    <h4>{`Properties`}</h4>
    <p>{`System props apply standard sets of properties to a component that can be used to alter its appearance on the fly.`}</p>
    <PropsTable name="Image" mdxType="PropsTable" />
    <h4>{`Accessibility`}</h4>
    <p><strong parentName="p">{`Alternative text`}</strong></p>
    <p>{`An image must always include an alternative text that provides a textual alternative description. The key principle is that computers and screen readers cannot analyze an image and determine what the image presents. As developers, text must be provided to the user which presents the content and function of the images within your web content.`}</p>
    <p><strong parentName="p">{`How do I write good alt text?`}</strong></p>
    <ul>
      <li parentName="ul">{`Describe the image as specifically and useful as possible.`}</li>
      <li parentName="ul">{`Keep it (relatively) short.`}</li>
      <li parentName="ul">{`Don't use images as text.`}</li>
      <li parentName="ul">{`Don't include "image of," "picture of," etc. in your alt text.`}</li>
      <li parentName="ul">{`Since writing good alternative text is critical to pass an accessibility audit please make sure to read the articles below on the Resources section.`}</li>
    </ul>
    <p><strong parentName="p">{`Resources`}</strong></p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://a11yproject.com/posts/alt-text/"
        }}>{`The A11Y Project`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.w3.org/WAI/tutorials/images/decision-tree/"
        }}>{`W3C: An alt Decision Tree`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://webaim.org/techniques/alttext/"
        }}>{`WebAIM`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      